import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00d1d1a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-shadow tr_row" }
const _hoisted_2 = { style: {"flex":"2"} }
const _hoisted_3 = {
  class: "switch-wrapper",
  style: {"flex":"3"}
}
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { style: {"flex":"2"} }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { style: {"flex":"2"} }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { style: {"flex":"2"} }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { style: {"flex":"2"} }

import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTElementShadow } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import { useI18n } from 'vue-i18n'
import ColorButton from './ColorButton.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import {
  Popover,
  Slider,
  Switch,
} from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ElementShadow',
  setup(__props) {

const { t, locale } = useI18n()

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const shadow = ref<PPTElementShadow>()
const hasShadow = ref(false)

watch(handleElement, () => {
  if (!handleElement.value) return
  shadow.value = 'shadow' in handleElement.value ? handleElement.value.shadow : undefined
  hasShadow.value = !!shadow.value
}, { deep: true, immediate: true })

const { addHistorySnapshot } = useHistorySnapshot()

const updateShadow = (shadowProps: Partial<PPTElementShadow>) => {
  if (!handleElement.value || !shadow.value) return
  const _shadow = { ...shadow.value, ...shadowProps }
  slidesStore.updateElement({ id: handleElement.value.id, props: { shadow: _shadow } })
  addHistorySnapshot()
}

const toggleShadow = (checked: boolean) => {
  if (!handleElement.value) return
  if (checked) {
    const _shadow: PPTElementShadow = { h: 1, v: 1, blur: 2, color: '#000' }
    slidesStore.updateElement({ id: handleElement.value.id, props: { shadow: _shadow } })
  }
  else {
    slidesStore.removeElementProps({ id: handleElement.value.id, propName: 'shadow' })
  }
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "row",
      style: _normalizeStyle(hasShadow.value ? 'margin-bottom: 10px;' : '')
    }, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`editor.toolbar.common.elementShadow.enable`)) + "：", 1),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Switch), {
          checked: hasShadow.value,
          onChange: _cache[0] || (_cache[0] = checked => toggleShadow(checked as boolean))
        }, null, 8, ["checked"])
      ])
    ], 4),
    (hasShadow.value && shadow.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t(`editor.toolbar.common.elementShadow.horizontal`)) + "：", 1),
            _createVNode(_unref(Slider), {
              class: "slider",
              min: -10,
              max: 10,
              step: 1,
              value: shadow.value.h,
              onChange: _cache[1] || (_cache[1] = value => updateShadow({ h: value as number }))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(`editor.toolbar.common.elementShadow.vertical`)) + "：", 1),
            _createVNode(_unref(Slider), {
              class: "slider",
              min: -10,
              max: 10,
              step: 1,
              value: shadow.value.v,
              onChange: _cache[2] || (_cache[2] = value => updateShadow({ v: value as number }))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t(`editor.toolbar.common.elementShadow.fuzzyDistance`)) + "：", 1),
            _createVNode(_unref(Slider), {
              class: "slider",
              min: 1,
              max: 20,
              step: 1,
              value: shadow.value.blur,
              onChange: _cache[3] || (_cache[3] = value => updateShadow({ blur: value as number }))
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t(`editor.toolbar.common.elementShadow.color`)) + "：", 1),
            _createVNode(_unref(Popover), { trigger: "click" }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: shadow.value.color,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = value => updateShadow({ color: value }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: shadow.value.color,
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})